import { useContext, useMemo } from 'react';
import { locales } from '../data/locales.esm.js';
import { AppContext } from '../components/context/context.esm.js';

var useLocale = function() {
    var _useContext = useContext(AppContext), localeStr = _useContext.locale, onLocaleChange = _useContext.onLocaleChange;
    var locale = useMemo(function() {
        return locales.find(function(param) {
            var locale = param.locale;
            return locale === (localeStr === null || localeStr === void 0 ? void 0 : localeStr.toLowerCase());
        }) || locales[0];
    }, [
        localeStr
    ]);
    return {
        locale: locale,
        onLocaleChange: onLocaleChange
    };
};

export { useLocale };
